// extracted by mini-css-extract-plugin
export default {"subTitle":"styles_subTitle__vRRal"};